<img src="../../../../assets/img/logo.svg" alt="" class="brand" />
<div class="title-row">
  <h1>Scénario</h1>
  <button
    mat-icon-button
    [style.transform]="'translateX(8px)'"
    aria-label="Example icon button with a vertical three dot icon"
    (click)="onClickInfo()"
  >
    <mat-icon>info</mat-icon>
  </button>
  <button
    mat-icon-button
    [style.transform]="'translateX(8px)'"
    aria-label="Example icon button with a vertical three dot icon"
    (click)="onClickReset()"
  >
    <mat-icon>refresh</mat-icon>
  </button>
</div>
<form [formGroup]="form">
  <div class="margin-wrapper">
    @for(cat of categories; track $index) {
    <mat-expansion-panel
      class="scenario-expansion-panel"
      (opened)="expandedPanels[cat.name] = true"
      (closed)="expandedPanels[cat.name] = false"
      [expanded]="expandedPanels[cat.name]"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{ cat.name }}</mat-panel-title>
      </mat-expansion-panel-header>

      @for (item of cat.items; track trackByItem($index, item)) {
      <ng-container>
        <span class="input-label">
          {{ item.name }}
        </span>

        <mat-form-field
          appearance="outline"
          class="scenario-field"
          [style.margin-bottom]="item.unit ? '16px' : 'auto'"
        >
          <ng-container *ngIf="item.options?.length; else inputField">
            <mat-select [formControlName]="controlKey(cat.name, item.name)">
              @for (option of item.options; track $index) {
              <mat-option [value]="option">
                {{ option }} {{ item.unit }}
              </mat-option>
              }
            </mat-select>
          </ng-container>

          <ng-template #inputField>
            <input
              matInput
              [formControlName]="controlKey(cat.name, item.name)"
              *ngIf="item.unit === '%'; else normalInput"
              percentInput
              type="text"
              inputmode="decimal"
            />
            <ng-template #normalInput>
              <input
                matInput
                [formControlName]="controlKey(cat.name, item.name)"
              />
            </ng-template>
            <span *ngIf="item.unit" matTextSuffix>{{ item.unit }}</span>
          </ng-template>
          <mat-hint *ngIf="item.comment">
            <button
              (click)="onClickOpenInfo(cat.name, item.name, item.comment)"
            >
              En savoir plus
            </button>
          </mat-hint>
        </mat-form-field>
      </ng-container>
      }
    </mat-expansion-panel>
    }
  </div>
</form>

<div class="footer">
  <span>Développé par</span>
  <img src="../../../../assets/img/logo_rweality.png" alt="" />
</div>
